import { Card } from 'react-bootstrap';
import './PublishMessageDetail.scss';
import { formatMessageDateAndTime } from 'src/common/utils';
import GenericButton from 'src/Components/GenericButton/GenericButton';

const PublishMessageDetail = ({
  selectedData,
  Sender_Email,
  getSanitizedContent,
}) => {
  return (
    <div className="published-message-detail-admin">
      <div className="message_detail_section">
        <Card className="card-area">
          <div className="d-flex justify-content-between flex-wrap panel-card-header p-3">
            <div className="d-flex flex-wrap">
              <div className="">
                <span className="message-detail-user-icon-img">
                  {Sender_Email[0]}
                </span>
              </div>
              <div className="message-from-data-container">
                <span className="msg_from">{selectedData?.EventTitle}</span>
                <br />
                <span>From: {Sender_Email}</span>
              </div>
            </div>

            <div className="d-flex flex-column text-right">
              <span className="user-type-data">
                {selectedData?.userType === 'Member'
                  ? 'Member/Dependent'
                  : selectedData?.userType}
              </span>
              <span className="msgreceivedinfo">
                {formatMessageDateAndTime(selectedData?.ReceivedDateTime)}
              </span>
            </div>
          </div>
          <div className="sent-to-container px-3">
            <div className="sent-to-text">Sent To: </div>
            <div className="sent-to-details-container">
              <div className="user-data">{selectedData?.userType}</div>
              <div className="view-details d-none">View Details</div>
            </div>
          </div>
          <div className="px-3 mt-3">
            <p
              className="msg_body"
              dangerouslySetInnerHTML={{
                __html: getSanitizedContent(selectedData)
                  ?.EventDesc?.trim()
                  ?.substring(
                    1,
                    getSanitizedContent(selectedData)?.EventDesc?.length - 1,
                  ),
              }}
            />
          </div>
          <div className="controllers-container d-none">
            <div className="discard-controller ">Discard</div>
            <div>
              <GenericButton
                onClick={() => {}}
                variant="secondary"
                className="w-fit px-4"
              >
                MODIFY
              </GenericButton>
            </div>
            <div>
              <GenericButton
                onClick={() => {}}
                variant="primary"
                className="w-fit px-4"
              >
                Duplicate
              </GenericButton>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PublishMessageDetail;
